import { Text } from '@mantine/core';

export const CALL_ERROR_TYPE_LABELS: Record<string, string> = {
  number_not_configured: 'Number not configured',
  flow_load_failed: 'Flow failed to load',
  transfer_failed: 'Transfer failed',
  transfer_to_agent_failed: 'Agent transfer failed',
  ai_agent_failed: 'AI agent failed',
  http_request_failed: 'HTTP request failed',
  crm_lookup_failed: 'CRM lookup failed',
  stuck_session: 'Stuck call',
  widget_error: 'Widget error',
};

const SIP_CAUSE_REASON: Record<string, string> = {
  '608': 'Rejected by destination call screening (SIP 608)',
  '607': 'Rejected by destination call screening (SIP 607)',
  '486': 'Destination busy (SIP 486)',
  '600': 'Destination busy (SIP 600)',
  '480': 'Destination temporarily unavailable (SIP 480)',
  '603': 'Call declined by destination (SIP 603)',
};

const DIAL_STATUS_REASON: Record<string, string> = {
  busy: 'Destination busy',
  'no-answer': 'No answer from destination',
  failed: 'Destination rejected the call',
  canceled: 'Caller hung up before connecting',
};

type TransferDetail = {
  kind: 'transfer';
  dialCallStatus?: string;
  dialCallSid?: string;
  sipHangupCause?: string;
  hangupCause?: string;
  hangupSource?: string;
};

function asTransferDetail(detail: unknown) {
  return detail && typeof detail === 'object' && (detail as { kind?: unknown }).kind === 'transfer'
    ? (detail as TransferDetail)
    : null;
}

function TransferErrorDetail({ detail }: { detail: TransferDetail }) {
  const raw = [
    detail.dialCallStatus,
    detail.sipHangupCause ? `SIP ${detail.sipHangupCause}` : undefined,
    detail.hangupCause,
    detail.hangupSource ? `from ${detail.hangupSource}` : undefined,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <>
      <Text size="xs" fw={600}>
        {(detail.sipHangupCause ? SIP_CAUSE_REASON[detail.sipHangupCause] : undefined) ??
          (detail.dialCallStatus ? DIAL_STATUS_REASON[detail.dialCallStatus] : undefined) ??
          'Did not connect'}
      </Text>
      {raw && (
        <Text size="xs" c="dimmed">
          {raw}
        </Text>
      )}
    </>
  );
}

export function CallErrorDetail({ detail }: { detail: unknown }) {
  const transfer = asTransferDetail(detail);

  return transfer ? <TransferErrorDetail detail={transfer} /> : null;
}
